<template lang="pug">
  .component-selectize-client
    selectize(v-if="options", :options="options", value-field="code", :maxItems="maxItems" label-field="name", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected", placeholder="Countries")
</template>

<script>
  import Selectize from "../../../Selectize";
  import BaseSelectize from './BaseSelectize'
  import CountryList from 'src/CountryList'

  export default {
    name: "SelectizeCountry",
    extends: BaseSelectize,
    components: {Selectize},
    data() {
      return {
        searchableFields: ['name', 'code']
      }
    },
    created() {
      this.options = CountryList.countries
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div><small>${item.code}</small></div><div>${item.name}</div></div>`
      },
      renderTemplate(item, escape) {
        return `<div><div><small>${item.code}</small></div><div>${item.name}</div></div>`
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeCountry.vue?1e605d54